import { z } from "zod";

export const zOption = z.object({
  label: z.string(),
  value: z.string(),
});

export type ZOption = z.infer<typeof zOption>;
